import axios from 'axios'

function downloadFromS3(url) {
  const a = document.createElement('a');
  a.href = url;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

function downloadFile(url, file, type, params) {
  const options = {
    headers: {'accept': type},
    responseType: 'blob',
    params
  };

  return axios.get(url, options).then(response => {
    const blob = new Blob([(response.data)], {type: type});
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.id = 'tmp-file-download';
    anchor.setAttribute('download', file);
    document.body.appendChild(anchor);
    anchor.click();
    document.getElementById(anchor.id).remove();
  });
}

export default {
  findCustomerBy: filters => axios.get(`/api/customers`, { params: filters }).then(({ data }) => data),
  findCustomerPreviewBy: filters => axios.get(`/api/customers/search/preview`, { params: filters }),
  findDuplicate: params => axios.get(`/api/customers/search/duplicate`, { params: params }),
  find: customerId => axios.get(`/api/customers/${customerId}`).then(({data}) => data),
  findBarcodesBy: customerId => axios.get(`/api/customers/${customerId}/barcodes`).then(({data}) => data),
  findOperationsBy: customerId => axios.get(`/api/customers/${customerId}/operations`).then(({data}) => data),
  disableBarcode: (customerId, barcode) => axios.put(`/api/customers/${customerId}/disable-barcode`, {barcode}),
  downloadCsv: filters => axios.get(`/api/V2/customers`, {headers: {'accept': 'text/csv'}, params: filters}).then(({data}) => data),
  fileDownload: (url) => downloadFromS3(url)
}
